import React, {Component} from "react";
import LoaderButton from "../components/LoaderButton";
import "./Discount.css";
import * as columnDefsDiscounts from "../libs/columnDefDiscounts";
import {AgGridReact} from "ag-grid-react";
import * as userLib from "../libs/user-lib";
import {validateFormDiscount} from "../libs/user-lib";
const API = require("../libs/awsApiWrappers");

export default class Discount extends Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoading: null,
            isDeleting: null,
            discount: null,

            // make a copy of the JSON structure as the underlying structure is modified
            columnDefs: JSON.parse(JSON.stringify(columnDefsDiscounts.columnDefsDiscounts)),

            defaultColDef: {
                resizable: true
            },

            style: {
                width: '100%',
                // height: '364px'
                height: '110px'
            },

            isEditor: userLib.isCustomEditor(this.props.currentUser, 'discount'),

            rowData: []
        };

        // disable tick box
        this.state.columnDefs[0].checkboxSelection = false;

        // update column definition
        columnDefsDiscounts.setColDefDiscountForDataEntry(true, this);
    }

    onGridReady = params => {
        this.gridApi = params.api;
        this.gridColumnApi = params.columnApi;

        const updateData = data => {
            this.setState({rowData: data});
        };

        updateData(this.state.rowData);
    };

    componentDidUpdate() {
        if (this.gridApi) {
            this.gridApi.refreshCells();
        }
    }

    async componentDidMount() {
        try {
            const discount = await this.getDiscount();
            this.setState({rowData: [discount]});
        } catch (e) {
           API.handleApiErrorWithAlert(e, this);
        }
        this.props.setUpdateTimeOutListener();
    }

    getDiscount() {
        return API.get("pumps", `/discounts/${this.props.match.params.id}`, {});
    }

    saveDiscount(discount) {
        let attrib;
        for (attrib in discount) {
            if (Object.prototype.hasOwnProperty.call(discount, attrib)) {
                if ("" === attrib) {
                }
                attrib = null;
            }
        }
        return API.put("pumps", `/discounts/${this.props.match.params.id}`, {
            body: discount
        });
    }

    deleteDiscount() {
        const options = {deleteItem: true};
        return API.put("pumps", `/discounts/${this.props.match.params.id}`, {
            body: options
        });
        // return API.del("pumps", `/discounts/${this.props.match.params.id}`, {});
    }

    handleSubmit = async event => {

        event.preventDefault();
        this.gridApi.stopEditing();
        if (validateFormDiscount(this)) {
            this.setState({isLoading: true});
            let element;
            try {
                element = this.gridApi.getDisplayedRowAtIndex(0).data;
                await this.saveDiscount(element);
                // reload data
                this.props.setRowDataDiscounts([]);
                this.props.history.push("/discounts");
            } catch (e) {
                API.handleApiErrorWithAlert(e, this);
                this.setState({isLoading: false});
            }
        }
    };

    handleDelete = async event => {
        event.preventDefault();

        const confirmed = window.confirm(
            "Are you sure you want to delete this discount? This cannot be undone."
        );

        if (!confirmed) {
            return;
        }

        this.setState({isDeleting: true});

        try {
            await this.deleteDiscount();
            this.props.setRowDataDiscounts([]);
            this.props.history.push("/discounts");
        } catch (e) {
            API.handleApiErrorWithAlert(e, this);
            this.setState({isDeleting: false});
        }
    };

    render() {
        return (
            <div className="Pumps">
                {this.state.rowData &&
                <form onSubmit={this.handleSubmit}>
                    <div
                        id="pumpGrid"
                        style={this.state.style}
                        className="ag-theme-balham"
                    >
                        <AgGridReact
                            columnDefs={this.state.columnDefs}
                            defaultColDef={this.state.defaultColDef}
                            getRowHeight={this.state.getRowHeight}
                            onGridReady={this.onGridReady}
                            enableCellTextSelection={true}
                            singleClickEdit={true}
                            // components={this.state.components}
                            rowData={this.state.rowData}
                            headerHeight={58}
                        />
                    </div>
                    {this.state.isEditor &&
                    <LoaderButton
                        block
                        bsStyle="primary"
                        bsSize="large"
                        type="submit"
                        isLoading={this.state.isLoading}
                        text="Save"
                        loadingText="Saving…"
                    />
                    }
                    {this.state.isEditor &&
                    <LoaderButton
                        block
                        bsStyle="danger"
                        bsSize="large"
                        isLoading={this.state.isDeleting}
                        onClick={this.handleDelete}
                        text="Delete"
                        loadingText="Deleting…"
                    />
                    }
                </form>}
            </div>
        );
    }
}
